import KlaviyoFormAtom from '@klv/atoms/klaviyo-form';
import type { TIconName } from '@klv/atoms/icon/types';
import * as s from './styles';
import type { IMoreCard } from './types';

const MoreCard = ({
  eyebrow,
  icon,
  richText = '',
  formId = '',
  button,
  ...props
}: IMoreCard) => (
  <s.StyledMoreCard hasFormId={formId !== ''} {...props}>
    {button && button.url && (
      <s.MoreLink
        aria-label={button.openInNewTab ? `${eyebrow} (opens in a new tab)` : ''}
        href={button.url}
        target={button.openInNewTab ? '_blank' : '_self'}
      />
    )}
    <s.InnerCard>
      <s.ContentContainer>
        <s.StyledEyebrow content={eyebrow} />
        <s.StyledIcon color="currentColor" iconName={icon.iconName as TIconName} size={3.2} />
        {formId && <KlaviyoFormAtom formId={formId} />}
        {richText && (
          <s.BodyText
            dangerouslySetInnerHTML={{ __html: richText }}
            variant="paragraph1"
          />
        )}
      </s.ContentContainer>
      {button && (
        <s.ButtonContainer>
          <s.StyledButton
            url={button.url}
            variant="tertiary"
            text={button.text}
            buttonColor="dark"
            openInNewTab={button.openInNewTab}
          />
        </s.ButtonContainer>
      )}
    </s.InnerCard>
  </s.StyledMoreCard>
);

export default MoreCard;
